import axios from "axios";
import {SERVER} from "../../Constants"

// API call to fetch pending photo verifications
const apiClient = axios.create({
    baseURL: SERVER+"/stats",
    withCredentials: true
});

export const getStats = async () => {
    try {
        const response = await apiClient.get('/');
        console.log("API response:", response); // Debugging log
        return response.data;
    } catch (error) {
        console.error("API error:", error.response); // Debugging log
        throw new Error(error.response?.data?.message || 'Failed to fetch data');
    }
};
